import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { CurrencyFormatter } from '@rakutenfrance/mui';
import { floaText, floaUrl, legalText, listForBlockFloa } from '../../../constants';
import { FloaLogo } from '@rakutenfrance/shared-svg';
import * as s from './FloaPanel.style';
export const FloaPanel = ({ schedules, fee }) => {
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: s.container },
            React.createElement(FloaLogo, null)),
        React.createElement(Box, { sx: s.headTitle }, "Comment \u00E7a marche ?"),
        listForBlockFloa.map((element, index) => {
            return (React.createElement(Box, { key: index, sx: s.listContainer },
                React.createElement(Box, { sx: s.circleContainer },
                    React.createElement(Box, { sx: s.circleContent }, element.order)),
                React.createElement(Typography, { variant: "body1", sx: s.title }, element.title)));
        }),
        React.createElement(Box, { sx: s.legalText },
            React.createElement(Box, null, legalText),
            React.createElement(Box, null,
                floaText,
                ' ',
                React.createElement(Box, { sx: s.linkText, component: 'a', href: floaUrl, target: "_blank", rel: "noopener noreferrer" },
                    ' ',
                    "ici."))),
        !!schedules && (React.createElement(Box, { sx: s.legalText },
            React.createElement(Box, null,
                "Pour un paiement en 10 fois, payer aujourd\u2019hui ",
                React.createElement(CurrencyFormatter, { amount: (schedules === null || schedules === void 0 ? void 0 : schedules[0].amount) / 100 }),
                " suivi de 9 mensualit\u00E9s de ",
                React.createElement(CurrencyFormatter, { amount: (schedules === null || schedules === void 0 ? void 0 : schedules[1].amount) / 100 })),
            React.createElement(Box, null,
                "Co\u00FBt du financement : ",
                React.createElement(CurrencyFormatter, { amount: fee ? fee / 100 : 0 })),
            React.createElement(Box, null, "TAEG fixe de 21,01%")))));
};
